var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8563 20.0788C16.9483 20.1726 17 20.3004 17 20.4337C17 20.567 16.9483 20.6948 16.8563 20.7887L15.826 21.8485C15.7378 21.9452 15.6147 22 15.4859 22C15.357 22 15.2339 21.9452 15.1457 21.8485L6.21382 12.6599C6.07708 12.5194 6.00017 12.3288 6 12.13V11.87C6.00017 11.6712 6.07708 11.4806 6.21382 11.3401L15.1457 2.1515C15.2339 2.05483 15.357 2 15.4859 2C15.6147 2 15.7378 2.05483 15.826 2.1515L16.8563 3.21133C16.9483 3.3052 17 3.43298 17 3.56628C17 3.69958 16.9483 3.82736 16.8563 3.92123L9.00321 12L16.8563 20.0788Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBack);
export default __webpack_public_path__ + "static/media/arrow-left-back.aff78bbd1c16e2ae0ab7274c4c08d43f.svg";
export { ForwardRef as ReactComponent };